// extracted by mini-css-extract-plugin
module.exports = {"content-small-card-wrapper":"ContentSmallCard_content-small-card-wrapper__9jEm5","content-small-card-footer":"ContentSmallCard_content-small-card-footer__Q8_rC"};